export default "__VITE_ASSET__D0Da2yBw__"